import { ReactNode } from 'react';
import cx from 'classnames';

import styles from './grid.module.scss';

export default function Grid({ children }: { children: ReactNode }) {
  return <div className={styles.grid}>{children}</div>;
}

function GridItem({ span = 1, children }: { span?: 1 | 2 | 4; children: ReactNode }) {
  return <div className={cx(styles['grid__item'], styles[`grid__item--span-${span}`])}>{children}</div>;
}

Grid.Item = GridItem;
